import { fbt } from 'fbtee'
import { Flame } from 'lucide-react'

/** Date-line marker for one of the most popular events in the viewer's region. */
export function PopularMark() {
  return (
    <span className="inline-flex shrink-0 items-center gap-1">
      <Flame className="size-3.5 text-warning" aria-hidden />
      {fbt('Popular', "Badge on an event card marking one of the most popular events in the viewer's region")}
    </span>
  )
}
